var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-product-sku-autocomplete", {
    ref: "productSku",
    attrs: {
      value: _vm.value,
      label: _vm.label,
      fancy: "",
      "auto-focus": _vm.autoFocus,
      disabled: _vm.disabled,
      "allow-multiple": _vm.allowMultiple,
      "include-disabled": _vm.includeDisabled,
      "remove-on-empty": _vm.removeOnEmpty,
      "show-stock-location": _vm.showStockLocation,
    },
    on: {
      fetching: function ($event) {
        return _vm.$emit("fetching", $event)
      },
      input: function ($event) {
        return _vm.productSelected($event)
      },
      inputs: function ($event) {
        return _vm.multipleProductsSelected($event)
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      text: function ($event) {
        return _vm.onText($event)
      },
      keyup: function ($event) {
        return _vm.onKeyUp($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }